import { z } from "zod";
const allowedPrimitives = z.union([
    z.null(),
    z.number(),
    z.bigint(),
    z.string(),
    z.boolean()
]);
export const parameterValues = z.union([
    allowedPrimitives,
    z.array(allowedPrimitives)
]);
export const eventSchema = z.object({
    event_name: z.string(),
    parameters: z.object({}).catchall(parameterValues).partial().default({}),
    created_at: z.string().refine((value)=>Date.parse(value) !== undefined).transform((v)=>new Date(v)),
    event_id: z.string().uuid()
});
export const eventsSchema = z.object({
    events: z.array(eventSchema)
});
/**
 * Context provided on every event.
 */ export const PlatformEnum = z.enum([
    "unknown",
    "iOS",
    "Mac",
    "Android"
]);
/**
 * EventContext
 *
 * Context surrounding the evnet like device user, etc.
 *
 * These are loosly mapped to event table
 *
 */ export const requestContextSchema = z.object({
    publicApiKey: z.string().optional(),
    aliases: z.array(z.string()).default([]),
    appUserId: z.string(),
    ipAddress: z.string().optional(),
    platform: z.string(),
    appVersion: z.string().optional(),
    sdkVersion: z.string().optional(),
    bundleId: z.string().optional(),
    radioType: z.string().optional(),
    lowPowerMode: z.string().optional(),
    // assignedPlatform Id
    vendorId: z.string().optional(),
    // Device things
    deviceOsVersion: z.string().optional(),
    deviceModel: z.string().optional(),
    deviceLocale: z.string().optional(),
    deviceLanguageCode: z.string().optional(),
    deviceCurrencyCode: z.string().optional(),
    deviceCurrencySymbol: z.string().optional(),
    deviceTimezoneOffset: z.string().optional(),
    deviceInstallTimestamp: z.string().optional(),
    deviceInterfaceStyle: z.string().optional(),
    sandbox: z.string().transform((x)=>x === "true").optional()
});
export const extraFieldsSchema = z.object({
    sandbox: z.boolean().optional()
});
export const IEventSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    timestamp: z.string(),
    source: z.string(),
    properties: z.string(),
    public_api_key: z.string(),
    app_user_id: z.string(),
    aliases: z.array(z.string()).default([]),
    vendor_id: z.string(),
    ip_address: z.string(),
    platform: z.string(),
    app_version: z.string(),
    sdk_version: z.string(),
    bundle_id: z.string(),
    radio_type: z.string(),
    low_power_mode: z.string(),
    device_os_version: z.string(),
    device_model: z.string(),
    device_locale: z.string(),
    device_language_code: z.string(),
    device_currency_code: z.string(),
    device_currency_symbol: z.string(),
    device_timezone_offset: z.string(),
    device_install_timestamp: z.string(),
    device_interface_style: z.string(),
    created_at: z.string(),
    // Omitting b/c new fields will just get added
    extra_fields: z.string(),
    // Omitting b/c using a dictGetLookup
    application_id: z.number(),
    organization_id: z.number(),
    // Omitting b/c we can parse it
    paywall_id: z.number(),
    // Omitting from events b/c no more aliasing
    application_user_alias_id: z.number(),
    application_user_id: z.number()
});
export const BaseEventSchema = IEventSchema.omit({
    // Omitting b/c new fields will just get added
    extra_fields: true,
    // Omitting b/c using a dictGetLookup
    application_id: true,
    organization_id: true,
    // Omitting b/c we can parse it
    paywall_id: true,
    // Omitting from events b/c no more aliasing
    application_user_alias_id: true,
    application_user_id: true
}).extend({
    sandbox: z.boolean().optional()
}) // const validated: Required<SnakeCasedProperties<IEvent>> = IEventSchema.parse({} as unknown as any)
 // console.log(`validated`, validated)
;
